import { api } from 'data/api/api'

import { UpdateDeliveryOptionChangeRequestArgs } from '../types/update-delivery-option'

export const updateDeliveryOptionChangeRequest = (args: UpdateDeliveryOptionChangeRequestArgs) =>
  api.patch(`/shipments/${args.shipmentId}/delivery_option_change_request`, {
    status: args.status,
    pickup_point_code: args.pickupPointCode,
  })
